import React from 'react';
import './App.css';
import MicrofinancePlatform from './MicrofinancePlatform';

function App() {
  return (
    <div className="App">
      <main>
        <MicrofinancePlatform />
      </main>
    </div>
  );
}

export default App;
